import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { ASC, IDLE, PENDING } from "const"
import {
    Lifecycle,
    CcRequirementLifecyclePhaseCreate,
} from "server/models"
import { StateType } from "client/utils"
import { sort } from "client/store/utils"
import {
    StoreType,
    CcRequirementProps,
    RequirementList,
    RequirementLifecyclePhaseList,

    LoadCcRequirementLifecyclePhases,
    LoadAllLifecycles,
    LoadAllLifecyclePhases,
    LoadCcRequirementById,
    DeleteCcRequirementLifecyclePhases,
    SaveCcRequirementLifecyclePhases,

    setCcRequirementLifecyclesEdit,
    setCcRequirementLifecyclePhaseListEdit,
    setCcRequirementList,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Loader,
    Button,
    SpinnerIcon,
} from "client/components"

import LifecyclePhases from "../requirementEdit/lifecyclePhases"

let isMounted: boolean

const ManageLifecyclePhases = ({
    requirementId = null,
}: CcRequirementProps) => {
    const requirementList = useSelector((state: StoreType) => state.ccRequirement.requirementList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [phases, setPhases] = useState<number[]>([])
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadCcRequirementLifecyclePhases(requirementId).then((res) => {
                const phaseIds: number[] = []
                res.forEach((row) => {
                    phaseIds.push(row.phaseId)
                })
                setPhases(phaseIds)
            }),
            LoadAllLifecycles(userData.accountId, project.id)
            .then(({ lifecycleList }) => {
                const lifecycles: Lifecycle[] = Object.values(lifecycleList)
                lifecycles.sort((a, b) => sort(a, b, "name", ASC))

                const promiseNestedArray: Promise<any>[] = []
                const phaseList: RequirementLifecyclePhaseList = {}

                lifecycles.forEach((lifecycle) => {
                    promiseNestedArray.push(
                        LoadAllLifecyclePhases(lifecycle.id).then((res) => {
                            res.sort((a, b) => sort(a, b, "name", ASC))
                            phaseList[lifecycle.id] = res
                        }),
                    )
                })
                return Promise.all(promiseNestedArray).then(() => {
                    dispatch(setCcRequirementLifecyclesEdit(lifecycles))
                    dispatch(setCcRequirementLifecyclePhaseListEdit(phaseList))
                })
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    const onClose = () => {
        if (modals.length && isMounted) dispatch(closeModal())
    }

    const onSave = () => {
        setSaveState(PENDING)

        const phaseData: CcRequirementLifecyclePhaseCreate[] = []
        phases.forEach((phaseId) => {
            phaseData.push({
                requirementId,
                phaseId,
            })
        })

        DeleteCcRequirementLifecyclePhases(requirementId, null).then(() => (
            SaveCcRequirementLifecyclePhases(phaseData).then(() => {
                // load updated requirement data
                LoadCcRequirementById(requirementId, project.id)
                .then((resRequirement) => {
                    const requirementListCopy: RequirementList = {
                        ...requirementList,
                        [resRequirement.id]: resRequirement,
                    }

                    dispatch(setCcRequirementList(requirementListCopy))
                    onClose()
                })
            })
        ))
    }

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editLifecyclePhases}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <LifecyclePhases
                                phases={phases}
                                setPhases={(newPhases) => setPhases(newPhases)}
                            />
                        </Col>
                        <Col xs={12}>
                            <Button variant="success" row onClick={onSave}>
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>
                            <Button row onClick={onClose}>{lang.cancel}</Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default ManageLifecyclePhases
